module.exports = __webpack_public_path__ + "img/bao_dampet.0c1e98b8.jpg";